module.exports = __webpack_public_path__ + "media/styles/images/svg/circle-check-gray-dark-on-white-d9bbed3c3ffd428724ab5fab2d474573.svg";